import { render, staticRenderFns } from "./Aprobacion.vue?vue&type=template&id=4585d865&scoped=true&"
import script from "./Aprobacion.vue?vue&type=script&lang=js&"
export * from "./Aprobacion.vue?vue&type=script&lang=js&"
import style0 from "./Aprobacion.vue?vue&type=style&index=0&id=4585d865&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4585d865",
  null
  
)

export default component.exports